import name from './name'

const selectSliceData = state => state[name]
const selectContentTab = state => selectSliceData(state).content
const selectUsageTab = state => selectSliceData(state).usage
const selectSkillBitesTab = state => selectSliceData(state).skillBites
const selectUsageBetaTab = state => selectSliceData(state).usageBeta
const selectFilters = state => selectSliceData(state).filters
const selectDates = state => {
  const { startDate, endDate } = selectFilters(state)
  return {
    startDate: startDate ? new Date(startDate) : null,
    endDate: endDate ? new Date(endDate) : null
  }
}

export {
  selectContentTab,
  selectUsageTab,
  selectSkillBitesTab,
  selectUsageBetaTab,
  selectFilters,
  selectDates
}
